const middleware = {}

middleware['gates'] = require('../middleware/gates.js')
middleware['gates'] = middleware['gates'].default || middleware['gates']

middleware['pageMeta'] = require('../middleware/pageMeta.js')
middleware['pageMeta'] = middleware['pageMeta'].default || middleware['pageMeta']

export default middleware
